import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "./ui/dialog";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { ExternalLink } from "lucide-react";
import { openExternal } from "../lib/native";

const BUCKET_LABEL = {
  before_due: "Before due",
  due_today: "Due today",
  overdue: "Overdue",
};

/**
 * Compose-and-send dialog for the WhatsApp button. Extracted from
 * SendWhatsAppButton so it isn't redeclared every render (previously caused
 * input focus to be dropped on every keystroke).
 */
export default function WhatsAppComposeDialog({
  open, onOpenChange, customer, bucket, setBucket, message, setMessage,
  numOk, link, onSend,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="wa-compose-dialog">
        <DialogHeader>
          <DialogTitle>WhatsApp · {customer?.name || "Customer"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="text-xs text-slate-500">
            To: <span className="font-mono text-slate-700">{customer?.mobile || "—"}</span>
            {!numOk && <span className="ml-2 text-red-600 font-semibold">· No mobile number on file</span>}
          </div>
          <div className="flex gap-1">
            {Object.keys(BUCKET_LABEL).map((b) => (
              <button
                key={b}
                type="button"
                onClick={() => setBucket(b)}
                data-testid={`wa-bucket-${b}`}
                className={`px-3 py-1.5 rounded-md text-xs font-semibold border ${
                  bucket === b
                    ? "bg-emerald-600 text-white border-emerald-600"
                    : "border-slate-200 text-slate-600 hover:bg-slate-50"
                }`}
              >
                {BUCKET_LABEL[b]}
              </button>
            ))}
          </div>
          <div className="space-y-1.5">
            <Label>Message</Label>
            <Textarea
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="font-mono text-sm"
              data-testid="wa-compose-message"
            />
            <div className="text-xs text-slate-500">
              Edit before sending if you need. Templates can be saved on the WhatsApp page.
            </div>
          </div>
          <DialogFooter>
            {link ? (
              <Button
                type="button"
                onClick={(e) => { onSend?.(e); openExternal(link); }}
                data-testid="wa-compose-send"
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
              >
                <ExternalLink className="w-4 h-4 mr-1.5" /> Open in WhatsApp
              </Button>
            ) : (
              <Button disabled className="bg-slate-300 text-slate-600">No mobile</Button>
            )}
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
